import { createSelector } from 'reselect'
import {
  NotificationListModel,
  NotificationListResponse,
} from 'src/models/notifications.models'
import { RootState } from 'src/redux/createRootReducer'

export const selectNotificationsListResponsesFromState = (
  state: RootState,
): Record<string, NotificationListResponse> =>
  state.app.notifications.listResponses

export const selectNotificationsUnreadCountFromState = (
  state: RootState,
): number => state.app.notifications.unreadCount

export const selectLoadingFromState = (state: RootState): boolean =>
  state.app.notifications.loading

export const selectNotificationsListModelsFromState = createSelector(
  [selectNotificationsListResponsesFromState],
  (notificationsListResponses) =>
    Object.values(notificationsListResponses).reduce<
      Record<NotificationListResponse['id'], NotificationListModel>
    >(
      (acc, curr) => ({
        ...acc,
        [curr.id]: new NotificationListModel(curr),
      }),
      {},
    ),
)
